import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-right\">\n<path d=\"M19,13H5c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S19.6,13,19,13z\" />\n<path d=\"M12,20c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6.3-6.3l-6.3-6.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l7,7\n\tc0.4,0.4,0.4,1,0,1.4l-7,7C12.5,19.9,12.3,20,12,20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol